var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Form } from 'antd';
import useDebouncedFunction from 'utils/hooks/useDebouncedFunction';
import { Select } from 'ui/styled';
import { GroupWrap } from '../styled';
import EditableAnswerField from './EditableAnswerField';
import { getNormalizeAnswers, getHiddenAnswer, getParsedAnswer, getAnswersWithValue, getUnblockedAnswers } from '../helpers/surveyHelpers';
import { requiredMessage } from '../helpers/formHelpers';
var SelectField = function (_a) {
    var _b;
    var answers = _a.answers, required = _a.required, setEditValue = _a.setEditValue, form = _a.form, isTicketSurvey = _a.isTicketSurvey;
    var _c = getNormalizeAnswers(answers), allAnswersWithValue = _c.allAnswersWithValue, inheritAnswers = _c.inheritAnswers, nonInheritAnswers = _c.nonInheritAnswers, hiddenAnswers = _c.hiddenAnswers;
    var selectedValues = (_b = allAnswersWithValue === null || allAnswersWithValue === void 0 ? void 0 : allAnswersWithValue.filter(function (i) { return i.kind === 'inherit'; })) === null || _b === void 0 ? void 0 : _b.map(function (i) { return i.id; });
    var options = inheritAnswers.map(function (_a) {
        var id = _a.id, title = _a.title;
        return ({
            value: id,
            label: title
        });
    });
    var onSelectAnswers = function (ids) {
        if (!(ids === null || ids === void 0 ? void 0 : ids.length)) {
            setEditValue([]);
            return;
        }
        var selectedChoices = answers.filter(function (i) { return ids.includes(i.id); });
        var otherAnswers = nonInheritAnswers.filter(function (a) { return !a.blocked_by_default && a.answer_value; });
        var hiddenWithValue = getAnswersWithValue(hiddenAnswers);
        var hiddenUnblocked = getUnblockedAnswers(selectedChoices, hiddenWithValue);
        setEditValue(__spreadArray(__spreadArray([], getParsedAnswer(__spreadArray(__spreadArray([], otherAnswers, true), hiddenUnblocked, true)), true), getParsedAnswer(selectedChoices, true), true));
    };
    var onInputChange = function (id, value) { return __awaiter(void 0, void 0, void 0, function () {
        var currentInput, otherAnswers, parsedOthers, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, form.validateFields([id])];
                case 1:
                    _a.sent();
                    currentInput = answers.find(function (i) { return i.id === id; });
                    otherAnswers = answers.filter(function (i) { return i.id !== id && i.answer_value; });
                    parsedOthers = getParsedAnswer(otherAnswers);
                    setEditValue(value
                        ? __spreadArray(__spreadArray([], parsedOthers, true), [{ id: currentInput.id, user_answer_value: value }], false) : parsedOthers);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error('Validation failed', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onInputDebounce = useDebouncedFunction(onInputChange, 500);
    return (_jsxs(GroupWrap, { children: [_jsx(Form.Item, { name: "select_answer", rules: [
                    {
                        required: isTicketSurvey && required,
                        message: requiredMessage
                    }
                ], initialValue: selectedValues, children: _jsx(Select, { mode: "multiple", options: options, value: selectedValues, onChange: onSelectAnswers, placeholder: "Select options", showSearch: true, allowClear: true, optionFilterProp: "label", "data-test": "survey_select" }) }), nonInheritAnswers.map(function (answer) { return (_jsx(EditableAnswerField, { required: required, kind: answer.kind, answer: answer, onInputChange: function (v) { return onInputDebounce(answer.id, v); }, isHidden: getHiddenAnswer(answer, answers), isTicketSurvey: isTicketSurvey }, answer.id)); })] }));
};
export default SelectField;
